import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveSec2Failure, saveSec2Success, updateSec2Failure, updateSec2Success } from './actions';

export function* saveSec2({ payload }) {
  try {
    yield call(api.post, 'api/sec2', payload.data, { withCredentials: true });

    yield put(saveSec2Success());

    toast.success('SEC2 criado com sucesso!')

    history.push('/specifications/pilar3/resources/sec2');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveSec2Failure());
  }
}

export function* updateSec2({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/sec2/${id}`, payload.data, { withCredentials: true });

    yield put(updateSec2Success());

    toast.success('SEC2 atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/sec2');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateSec2Failure());
  }
}

export default all([
  takeLatest('@sec2/SAVE_REQUEST', saveSec2),
  takeLatest('@sec2/UPDATE_REQUEST', updateSec2)
]);